import { ImagePropsForDropZone } from '../../types/image'
import {
  AssociatedGateway,
  BookingRedirect,
  SiteKeyUpload
} from '../../types/sitekey'

const stripImageDisplayFields = (
  image?: ImagePropsForDropZone
): ImagePropsForDropZone | undefined => {
  if (!image) return image
  const { displayEntityCode, ...rest } = image
  return rest
}

export const buildSiteKeyUpdatePayload = (
  values: SiteKeyUpload,
  bookingRedirects: BookingRedirect[],
  associatedGateways: AssociatedGateway[]
) => {
  const { SiteKey, DisplayEntityCode, Email, Logo, Favicon, ...rest } = values

  return {
    ...rest,
    BookingRedirects: bookingRedirects,
    AssociatedGateways: associatedGateways,
    Logo: {
      EN: stripImageDisplayFields(Logo.EN),
      FA: stripImageDisplayFields(Logo.FA)
    },
    Favicon: {
      EN: stripImageDisplayFields(Favicon.EN),
      FA: stripImageDisplayFields(Favicon.FA)
    }
  }
}
